import { EditProps, ListProps, CreateProps } from "react-admin";
import Media from "./Utils/Media/Media";
const { MediaCreate, MediaEdit, MediaList } = Media;

export const GalleryList = (props: ListProps) => <MediaList {...props} />;

export const GalleryEdit = (props: EditProps) => <MediaEdit {...props} />;

export const GalleryCreate = (props: CreateProps) => <MediaCreate {...props} />;
